import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { LanguageSwitcher } from '../common/LanguageSwitcher';
import ProfileDropdown from './ProfileDropdown';

interface PublicNavBarProps {
  maxWidth?: string;
}

// Defaults to the same 1200px measure as `GlobalNavBar`, the MainPage sections
// and `SiteFooter`, so the nav, the content and the footer all line up.
const PublicNavBar: React.FC<PublicNavBarProps> = ({ maxWidth = 'max-w-[1200px]' }) => {
  const { isAuthenticated } = useAuthStore();
  const { t } = useTranslation('common');

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className={`${maxWidth} mx-auto px-4 h-14 flex items-center justify-between`}>
        <Link to="/" className="flex-shrink-0 flex items-center">
          <img src="/matchgo_logo_black.png" alt="MatchGo" className="h-8" />
        </Link>
        <div className="flex-shrink-0 flex items-center gap-1">
          <LanguageSwitcher compact />
          {isAuthenticated ? (
            <ProfileDropdown />
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-gray-600 hover:text-gray-900 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors">
                {t('publicDashboard.login')}
              </Link>
              <Link to="/register" className="text-sm font-medium px-4 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors">
                {t('publicDashboard.register')}
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default PublicNavBar;
